import React, { useEffect, useState, useContext } from 'react';
import { Auth } from './Features/Auth';
import { Main } from './Features/Main/';
import { NotFound } from './Features/NotFound/';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { FirebaseContext } from "./FirebaseContext";
import { TopBar } from "./Features/TopBar/";
import './App.css';

export const App = () => {
    const [userAuth, setUserAuth] = useState(null);
    const { loading, userData } = useContext(FirebaseContext);

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setUserAuth(user);
        });
    
        return () => unsubscribe(); // Cleanup the subscription on unmount
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }
    
    if (userAuth && userData) {
        return (
            <Router>
                <TopBar />
                <div className="main-content">
                    <Routes>
                        <Route path="/" element={<Navigate to="/home" />} />
                        <Route path="/home" element={<Main />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </div>
            </Router>
        );
    }
    
    return <Auth />;
}
